import React from 'react';
import MetaDecorator from '../components/MetaDatos/MetaDecorator';
import BannerVideo from '../components/FormBooking/BannerVideo';
//import BannerMain from '../components/FormBooking/BannerMain';
import ServiceDev from '../components/FormBooking/ServicesDev';
import Form from '../components/FormBooking/Form/Form';
import BannerAccion from '../components/FormBooking/BannerAccion/BannerAccion';
import BestDev from '../components/FormBooking/BestDev/BestDev';
import HorizonScene from '../components/FormBooking/HorizonScene';
import './../components/FormBooking/formStyles.css';
import { useTranslation } from 'react-i18next';



function MeetingPage() {

  const { t } = useTranslation('translation', { keyPrefix: 'metaDecorator' });


  return (
    <>
        <MetaDecorator 
        title={t('metaTitle_Landing')}
        description={t('metaDescription_Landing')}
        url="" />
        <div className='bg-darkblue booking'>
            {/* <BannerMain /> */}
            <HorizonScene />
            <BestDev />
            <ServiceDev />
            <Form />
            <BannerAccion />
            <BannerVideo />
        </div>
    </>
  )
}

export default MeetingPage;